//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["data"],
  block: 'Circles',
}



// WEBPACK FOOTER //
// ./components/blocks/Circles.vue